import { all, call, put, takeEvery } from 'redux-saga/effects'
import { actions } from '@redux/personalizacionProducto/actions'
import {
  deleteLegoPropsByProductoId,
  getPersonalizacionByProducto,
  insertLegoPropsProductoId,
  updateLegoPropsProductoId,
} from 'services/personalizacion'
import { messageType, putMessage } from 'utiles/mensaje'

export function* GET_PERSONALIZACION_BY_PRODUCTO(action) {
  try {
    const productosAdicionalesData = yield call(getPersonalizacionByProducto, action.payload)
    if (productosAdicionalesData.ok) {
      yield put({
        type: actions.GET_PERSONALIZACION_BY_PRODUCTO_SUCCEEDED,
        payload: productosAdicionalesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar productos adicionales del producto')
      put({
        type: actions.GET_PERSONALIZACION_BY_PRODUCTO_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.GET_PERSONALIZACION_BY_PRODUCTO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_LEGOPROPS_PRODUCTO(action) {
  try {
    const legoPropsData = yield call(insertLegoPropsProductoId, action.payload)
    if (legoPropsData.ok) {
      putMessage(messageType.SUCCESS, 'Guardado correctamente')
      yield put({
        type: actions.INSERT_LEGOPROPS_PRODUCTO_SUCCEEDED,
        payload: legoPropsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al guardar')
      put({
        type: actions.INSERT_LEGOPROPS_PRODUCTO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al guardar')
    yield all([
      put({
        type: actions.INSERT_LEGOPROPS_PRODUCTO_FAILED,
        error: e.message,
      }),
    ])
  }
}
export function* UPDATE_LEGOPROPS_PRODUCTO(action) {
  try {
    const legoPropsData = yield call(updateLegoPropsProductoId, action.payload)
    if (legoPropsData.ok) {
      putMessage(messageType.SUCCESS, 'Guardado correctamente')
      yield put({
        type: actions.UPDATE_LEGOPROPS_PRODUCTO_SUCCEEDED,
        payload: legoPropsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al guardar')
      put({
        type: actions.UPDATE_LEGOPROPS_PRODUCTO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al guardar')
    yield all([
      put({
        type: actions.UPDATE_LEGOPROPS_PRODUCTO_FAILED,
        error: e.message,
      }),
    ])
  }
}
export function* DELETE_LEGOPROPS_PRODUCTO(action) {
  try {
    const legoPropsData = yield call(deleteLegoPropsByProductoId, action.payload)
    if (legoPropsData.ok) {
      putMessage(messageType.SUCCESS, 'Eliminado correctamente')
      yield put({
        type: actions.DELETE_LEGOPROPS_PRODUCTO_SUCCEEDED,
        payload: legoPropsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar')
      put({
        type: actions.DELETE_LEGOPROPS_PRODUCTO_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar')
    yield all([
      put({
        type: actions.DELETE_LEGOPROPS_PRODUCTO_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_PERSONALIZACION_BY_PRODUCTO_REQUESTED, GET_PERSONALIZACION_BY_PRODUCTO),
    takeEvery(actions.INSERT_LEGOPROPS_PRODUCTO_REQUESTED, INSERT_LEGOPROPS_PRODUCTO),
    takeEvery(actions.UPDATE_LEGOPROPS_PRODUCTO_REQUESTED, UPDATE_LEGOPROPS_PRODUCTO),
    takeEvery(actions.DELETE_LEGOPROPS_PRODUCTO_REQUESTED, DELETE_LEGOPROPS_PRODUCTO),
  ])
}
